import { KITCHEN_PDP_CDN_PATH } from '../../kitchen-pdp-constants';

export const CATEGORY_CARD_LIST = [
  {
    name: 'Стеновые панели',
    imgSrc: `${KITCHEN_PDP_CDN_PATH}/categories/wall-panels.png/wall-panels.png`,
    alt: 'Стеновые панели',
    link: {
      href: '/catalogue/stenovye-paneli/',
      title: 'Стеновые панели',
    },
  },
  {
    name: 'Столешницы',
    imgSrc: `${KITCHEN_PDP_CDN_PATH}/categories/countertops.png/countertops.png`,
    alt: 'Столешницы',
    link: {
      href: '/catalogue/stoleshnicy-i-komplektuyushchie/',
      title: 'Столешницы и комплектующие',
    },
  },
  {
    name: 'Кухонные столы и\u00A0стулья',
    imgSrc: `${KITCHEN_PDP_CDN_PATH}/categories/kitchen-tables-and-chairs.png/kitchen-tables-and-chairs.png`,
    alt: 'Кухонные столы и стулья',
    link: {
      href: '/catalogue/stoly-i-stulya/',
      title: 'Столы и стулья',
    },
  },
  {
    name: 'Бытовая техника для кухни',
    imgSrc: `${KITCHEN_PDP_CDN_PATH}/categories/household-appliances-for-the-kitchen.png/household-appliances-for-the-kitchen.png`,
    alt: 'Бытовая техника для кухни',
    link: {
      href: '/catalogue/bytovaya-tehnika-dlya-kuhni/',
      title: 'Бытовая техника для кухни',
    },
  },
  {
    name: 'Мелкая бытовая техника',
    imgSrc: `${KITCHEN_PDP_CDN_PATH}/categories/small-household-appliances.png/small-household-appliances.png`,
    alt: 'Мелкая бытовая техника',
    link: {
      href: '/catalogue/melkaya-bytovaya-tehnika/',
      title: 'Мелкая бытовая техника',
    },
  },
  {
    name: 'Организация хранения на\u00A0кухне',
    imgSrc: `${KITCHEN_PDP_CDN_PATH}/categories/kitchen-storage.png/kitchen-storage.png`,
    alt: 'Организация хранения на кухне',
    link: {
      href: '/catalogue/organizaciya-hraneniya-na-kuhne/',
      title: 'Организация хранения на кухне',
    },
  },
  {
    name: 'Посуда для приготовления блюд',
    imgSrc: `${KITCHEN_PDP_CDN_PATH}/categories/utensils-for-cooking.png/utensils-for-cooking.png`,
    alt: 'Посуда для приготовления блюд',
    link: {
      href: '/catalogue/posuda-dlya-prigotovleniya-blyud/',
      title: 'Посуда для приготовления блюд',
    },
  },
  {
    name: 'Кухонные аксессуары',
    imgSrc: `${KITCHEN_PDP_CDN_PATH}/categories/kitchen-accessories.png/kitchen-accessories.png`,
    alt: 'Кухонные аксессуары',
    link: {
      href: '/catalogue/kuhonnye-aksessuary/',
      title: 'Кухонные аксессуары',
    },
  },
];
